import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const section = document.getElementById('heads-turning');
const intro = section.querySelector('.heads-turning__intro');
const introLine = section.querySelector('.heads-turning__intro__line');

const onEnter = () => {
  gsap.timeline()
    .to(intro, {
      y: 0,
      autoAlpha: 1,
      duration: 0.5,
    })
    .to(introLine, {
      scaleY: 1.0,
      duration: 0.5,
    }, '-=0.5');
};
const onLeave = () => {
  gsap.timeline()
    .to(introLine, {
      scaleY: 1.0,
      duration: 0.5,
    })
    .to(intro, {
      autoAlpha: 0,
      duration: 0.2,
    }, '-=0.5');
};

gsap.set(intro, { autoAlpha: 0, y: '+=100' });
gsap.set(introLine, { scaleY: 0 });

// Pin section.
gsap.timeline({
  scrollTrigger: {
    pin: section,
    end: '+=1000',
    scrub: true,
    fastScrollEnd: true,
  },
});

// Animate section contents.
gsap.timeline({
  scrollTrigger: {
    trigger: section,
    start: 'top top',
    // end: '-=500',
    fastScrollEnd: true,
    scrub: true,
    onEnter,
    onEnterBack: onEnter,
    onLeave,
    onLeaveBack: onLeave,
  },
});
